/**
 *   Created by FANGlh on 2018/11/26 12:41.
 *   Desc:
 */

import React,{Component} from 'react';
import './Approvel.css';
import icon_out from '../../../style/imgs/out_img.png';
import icon_res from '../../../style/imgs/res_img.png';
import icon_trip from '../../../style/imgs/trip_img.png';
import icon_leave from '../../../style/imgs/leave_img.png';
import {Link} from 'react-router-dom';
import {getIntValue, getStrValue, isObjEmpty} from "../../../utils/common";


export default class ApprovelItem extends Component{
    constructor(props){
        super(props);
        this.state={
            itemdata:this.props.itemdata,
            isMyApply:this.props.isMyApply,
            approveId:this.props.itemdata.approveId
        }
    }
    componentDidMount(){
        this.setState({
            itemdata:this.props.itemdata,
            isMyApply:this.props.isMyApply,
            approveId:this.props.itemdata.approveId
        },function () {
            // console.log('itemdata',this.state.itemdata)
        })

    }
    render(){

        const {itemdata,isMyApply,approveId} = this.state
        return(
                    <div style={{padding:10,paddingBottom:0}}>
                        <Link to={"/approvel-detail/" + isMyApply +"/"+ approveId }>
                            <div className="item-Style" onClick={this.ItemClick.bind(this,isMyApply,itemdata,this.props.index)}>
                                <div style={{width:'18%'}}>
                                    <div style={{width:76,height:'100%'}}>
                                        <img src={itemdata.approveType == 1 ? icon_trip : (itemdata.approveType == 2 ? icon_res : icon_leave)} className={isMyApply==true?'img_sty':"img_circle"}/>
                                    </div>
                                </div>
                                <div style={{width:'65%'}}>
                                    <div style={{color:"#333333",fontSize:15,marginTop:10}}>
                                        {itemdata.approveType == 1 ? '出差申请' :  (itemdata.approveType == 2 ? '用品申请' : '请假申请' )}
                                    </div>
                                    <div style={{color:"#666666",fontSize:12,marginTop:5}}>{this.props.itemdata.creatDate}</div>
                                </div>
                                <div className={itemdata.approveStatus==1?'doing':'done'}
                                     style={{textAlign:'left',marginTop:10,fontSize:12,width:'15%'}}>
                                    {itemdata.approveStatus == 1 ? "待审批" :"已审批"}
                                </div>
                            </div>
                        </Link>
                    </div>
        )
    }
    ItemClick =(isMyApply,data,index)=>{
        // console.log('type,data',type+'--'+data);
        this.props.onItemClick(isMyApply,index)
        return
        if(isMyApply){
            this.props.clickApplyItem(data)
        } else {
            this.props.clickApprovelItem(data)
        }
    }
}